import { TaskTypeEnum } from 'constants/types'

export const CACHE_KEYS = {
  TOKEN: 'authenticationToken',
}

export const LOCAL_STORAGE_KEYS = {
  TOKEN: 'authToken',
  TOKEN_LOGIN: 'tokenLogin',
  CUSTOMERS_SEARCH_FIELD: 'customersSearchField',
  CUSTOMERS_STATUS_FIELD: 'customersStatusField',
  USER_EMAIL: 'userEmail',
}

export const SUPPORTED_VIDEO_TYPES = {
  MP4: 'mp4',
  MOV: 'mov',
}

export const SUPPORTED_AUDIO_TYPES = {
  MP3: 'mp3',
  WAV: 'wav',
  M4A: 'm4a',
  OGG: 'ogg',
}

export const PASSWORD_MIN_LENGTH = 6

export const DEFAULT_RRULE = `DTSTART:${new Date(
  +new Date(new Date().getTime() - new Date().getTimezoneOffset() * 60000),
)
  .toISOString()
  .substring(0, 10)
  .replace(/-/g, '')}T010000Z
  RRULE:FREQ=DAILY;INTERVAL=1`

export const GRAPHQL_INITIAL_STATE = {
  hasError: false,
  hasSuccess: false,
  isLoggedIn: !!localStorage.getItem('authToken'),
}

export const DOCUSIGN_INTEGRATION_KEY =
  process.env.REACT_APP_DOCUSIGN_INTEGRATION_KEY
export const DOCUSIGN_BASE_URL = process.env.REACT_APP_DOCUSIGN_BASE_URL
export const BACKEND_URL = process.env.REACT_APP_GRAPHQL_BACKEND_URL

export const GOOGLE_CALENDAR_CLIENT_ID =
  process.env.REACT_APP_GOOGLE_CALENDAR_CLIENT_ID

export const GOOGLE_GMAIL_CLIENT_ID =
  process.env.REACT_APP_GOOGLE_CALENDAR_CLIENT_ID

export const GOOGLE_DRIVE_CLIENT_ID =
  process.env.REACT_APP_GOOGLE_DRIVE_CLIENT_ID

export const NOTION_OAUTH_CLIENT_ID =
  process.env.REACT_APP_NOTION_OAUTH_CLIENT_ID

export const OUTLOOK_CLIENT_ID = process.env.REACT_APP_OUTLOOK_CLIENT_ID
export const ZOOM_CLIENT_ID = process.env.REACT_APP_ZOOM_CLIENT_ID

export const DOCEBO_CLIENT_ID = process.env.REACT_APP_DOCEBO_CLIENT_ID
export const GOTO_CLIENT_ID = process.env.REACT_APP_GOTO_CLIENT_ID

export const TANGELO_OKTA_CLIENT_ID =
  process.env.REACT_APP_TANGELO_OKTA_CLIENT_ID
export const TANGELO_OKTA_DOMAIN = process.env.REACT_APP_TANGELO_OKTA_DOMAIN
export const TANGELO_OKTA_ISSUER_URL = `https://${TANGELO_OKTA_DOMAIN}`

export const OKTA_REDIRECT_PATH = '/sso-login'
export const CROSS_DOMAIN_STORAGE_URL =
  process.env.REACT_APP_CROSS_DOMAIN_STORAGE_URL

export const FULLSTORY_ORG_ID = process.env.REACT_APP_FULLSTORY_ORG_ID

export const TASK_TYPES = [
  {
    title: 'Complete',
    taskType: TaskTypeEnum.TOGGLE,
  },
  {
    title: 'Email',
    taskType: TaskTypeEnum.EMAIL,
  },
  {
    title: 'Calendar Event',
    taskType: TaskTypeEnum.CALENDAR_EVENT,
  },
  {
    title: 'Info',
    taskType: TaskTypeEnum.INFO,
  },
  {
    title: 'Multiple Choice',
    taskType: TaskTypeEnum.MULTIPLE_OPTION,
  },
  {
    title: 'Comment',
    taskType: TaskTypeEnum.TEXT,
  },
  {
    title: 'Upload Media',
    taskType: TaskTypeEnum.UPLOAD_MEDIA,
  },
  {
    title: 'DocuSign',
    taskType: TaskTypeEnum.DOCUSIGN,
  },
  {
    title: 'E-Sign',
    taskType: TaskTypeEnum.SIGN,
  },
  {
    title: 'Quiz',
    taskType: TaskTypeEnum.QUIZ,
  },
  {
    title: 'Survey',
    taskType: TaskTypeEnum.SURVEY,
  },
  {
    title: 'Scorecard',
    taskType: TaskTypeEnum.SCORECARD,
  },
  {
    title: 'Slack',
    taskType: TaskTypeEnum.SLACK_MESSAGE,
  },
  {
    title: 'Send Safely',
    taskType: TaskTypeEnum.SEND_SAFELY,
  },
  {
    title: 'SMS',
    taskType: TaskTypeEnum.SMS,
  },
  {
    title: 'Video',
    taskType: TaskTypeEnum.VIDEO,
  },
  {
    title: 'Audio',
    taskType: TaskTypeEnum.AUDIO,
  },
  {
    title: 'Docebo',
    taskType: TaskTypeEnum.DOCEBO,
  },
  {
    title: 'SCORM Course',
    taskType: TaskTypeEnum.SCORM_COURSE,
  },
  {
    title: 'AI Roleplay',
    taskType: TaskTypeEnum.AI_ROLEPLAY,
  },
]

export const LOCATION_HIERARCHY_STATES = [
  {
    value: 'ACTIVE',
    label: 'active',
  },
  {
    value: 'INACTIVE',
    label: 'inactive',
  },
  {
    value: 'PROFILE',
    label: 'profile',
  },
]

export const DATE_FORMAT_SHORT = 'yyyy-MM-dd'
export const BLOCKED_BY_OVERRIDE_RULE_DATE = '2100-12-31'
// ENGG-10286: task_property_name of a skipped session's move (backend
// GroupTasks::SessionMove), the override value that names the session date
// (GroupTask) the skipped date's employees were moved to.
export const SESSION_MOVE_OVERRIDE_PROPERTY = 'session'
// ENGG-8946: NotificationErrorHistory cause set by the backend when a task can't
// be assigned because the employee is missing a required date it depends on.
export const MISSING_DATE_CAUSE = 'MISSING_DATE'
export const STATIC_ROLES = ['Manager', 'Employee']

export const VALIDATION_SETTINGS = {
  EMAIL: {
    // ENGG-9289: apostrophes are legal in the local part and the backend
    // accepts them, so they must not be rejected by the admin forms.
    value: /^[A-Z0-9._%+'-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
    message: 'Invalid email address',
  },
}

export const AVAILABLE_LOCALES = [
  {
    label: 'English',
    value: 'en',
  },
  {
    label: 'French',
    value: 'fr',
  },
  {
    label: 'French (Canada)',
    value: 'fr-CA',
  },
  {
    label: 'Spanish',
    value: 'es',
  },
  {
    label: 'Portuguese',
    value: 'pt',
  },
  {
    label: 'Japanese',
    value: 'ja',
  },
  {
    label: 'German',
    value: 'de',
  },
  {
    label: 'Chinese (China)',
    value: 'zh-CN',
  },
  {
    label: 'Chinese (Taiwan)',
    value: 'zh-TW',
  },
]

export const DEFAULT_USERS_PAGINATION_FOR_IMPORT_MODALS = {
  page: 1,
  perPage: 999,
}

export const DEFAULT_DAYS_DATE_SETTINGS = 7
export const DEFAULT_AUTO_IMPORT_DAYS_AFTER = 30

export const DEFAULT_PAGINATION_FOR_PUBLISH_TASK_AND_TEMPLATE = {
  page: 1,
  perPage: 300,
}
